<template lang="pug">
include base.pug
</template>

<script>
export default {};
</script>

